import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { inputCls, btnPrimary } from "@/components/Form";
import AuthCard from "@/components/AuthCard";

export default function ForcePasswordChange() {
  const { refresh, signOut } = useAuth();
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) { toast.error("As senhas não conferem"); return; }
    setBusy(true);
    try { await api.post("/auth/change-password", { new_password: pw.a }); toast.success("Senha alterada!"); await refresh(); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthCard eyebrow="Segurança" title="Crie uma nova senha" desc="Você entrou com uma senha provisória. Para continuar, defina sua nova senha.">
      <form onSubmit={submit} className="space-y-4" data-testid="force-password-form">
        <input data-testid="force-new-password-input" required minLength={6} type="password" placeholder="Nova senha" className={inputCls} value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} />
        <input data-testid="force-confirm-password-input" required minLength={6} type="password" placeholder="Confirmar nova senha" className={inputCls} value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} />
        <button data-testid="force-submit-btn" disabled={busy} className={`${btnPrimary} w-full`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />}Salvar e continuar</button>
      </form>
      <button data-testid="force-logout-btn" onClick={signOut} className="mt-4 w-full text-center text-sm text-slate-500 hover:underline">Sair</button>
    </AuthCard>
  );
}
